import { motion, useIsPresent } from "framer-motion";
import { classNames } from "src/helpers/classNames";

const TableRow = ({ keyId, children, lastRow, classes = "" }) => {
  let isPresent = useIsPresent();
  let generateStyle = () => {
    if (isPresent) {
      return {
        position: "relative",
      };
    } else {
      return {
        position: "absolute",
        display: "flex",
        alignItems: "center",
      };
    }
  };

  return (
    <motion.tr
      layout
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ opacity: { duration: 0.3 } }}
      style={generateStyle}
      key={keyId}
      className={classNames("relative", classes, lastRow ? "rounded-xl" : "")}>
      {children}
    </motion.tr>
  );
};

export default TableRow;
